import { useEffect, useState } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import {
  ESTILO_BOTON_MODAL_ACEPTAR,
  ESTILO_BOTON_MODAL_CANCELAR,
  ESTILO_INPUT_GENERICO,
} from "../utils/const/estilos-const";

const CANTIDAD_MAX_LENGTH = 10;

export default function ModalRequerimientoProducto({
  isOpen,
  listaProductos = [],
  rowsDataLength = 0,
  productoEditar = null,
  onCancel,
  onAceptar,
}) {
  const { t } = useTranslation();
  const [productoSelected, setProductoSelected] = useState(null);
  const [cantidad, setCantidad] = useState("");
  const isEdit = productoEditar != null;

  useEffect(() => {
    if (!isOpen) return;

    if (productoEditar) {
      const matchedProducto =
        listaProductos.find(
          (item) => String(item.value) === String(productoEditar.idProducto)
        ) ??
        (productoEditar.idProducto != null
          ? {
              value: productoEditar.idProducto,
              label: productoEditar.producto ?? String(productoEditar.idProducto),
            }
          : null);

      setProductoSelected(matchedProducto);
      setCantidad(String(productoEditar.cantidad ?? ""));
      return;
    }

    setProductoSelected(null);
    setCantidad("");
  }, [isOpen, productoEditar, listaProductos]);

  if (!isOpen) return null;

  const handleCantidadChange = (event) => {
    const digitsOnly = event.target.value.replace(/[^0-9]/g, "");
    if (digitsOnly.length <= CANTIDAD_MAX_LENGTH) {
      setCantidad(digitsOnly);
    }
  };

  const handleCancel = () => {
    setProductoSelected(null);
    setCantidad("");
    onCancel?.();
  };

  const handleAceptar = () => {
    if (!productoSelected) {
      alert(t("alert_debe_seleccionar_producto"));
      return;
    }
    if (!cantidad || String(cantidad).trim().length === 0) {
      alert(t("alert_debe_ingresar_cantidad"));
      return;
    }

    onAceptar?.({
      id: isEdit ? productoEditar.id : (rowsDataLength + 1) * -1,
      productSelected: productoSelected,
      cantidad,
      isEdit,
    });
    setProductoSelected(null);
    setCantidad("");
  };

  const selectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 10000 }),
    menu: (base) => ({ ...base, zIndex: 10000 }),
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-gray-500 opacity-75" onClick={handleCancel} />
      <div className="relative z-50 bg-white w-full max-w-md sm:max-w-lg md:max-w-xl rounded-lg shadow-xl max-h-[90vh] overflow-y-auto">
        <div className="p-4 sm:p-6">
          <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4">
            {isEdit ? t("label_modificar_producto") : t("label_agregar_producto")}
          </h3>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("label_producto")}
                <span className="text-red-500">*</span>
              </label>
              <Select
                options={listaProductos}
                isSearchable
                isClearable={!isEdit}
                isDisabled={isEdit}
                value={productoSelected}
                onChange={setProductoSelected}
                placeholder={t("placeholder_seleccione_producto")}
                classNamePrefix="react-select"
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>

            <div>
              <label
                htmlFor="cantidad"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                {t("label_cantidad")}
                <span className="text-red-500">*</span>
              </label>
              <input
                id="cantidad"
                name="cantidad"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={cantidad}
                onChange={handleCantidadChange}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    handleAceptar();
                  }
                }}
                className={ESTILO_INPUT_GENERICO}
                maxLength={CANTIDAD_MAX_LENGTH}
                placeholder={t("placeholder_ingresa_cantidad")}
              />
              <p className="text-sm text-gray-500 flex justify-end mt-1">
                {cantidad.length}/{CANTIDAD_MAX_LENGTH}
              </p>
            </div>
          </div>

          <div className="flex justify-between items-center gap-3 mt-6">
            <button
              type="button"
              className={ESTILO_BOTON_MODAL_CANCELAR}
              onClick={handleCancel}
            >
              {t("label_cancelar")}
            </button>
            <button
              type="button"
              className={ESTILO_BOTON_MODAL_ACEPTAR}
              onClick={handleAceptar}
            >
              {t("label_aceptar")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
